import { selectAllEntities } from '@ngneat/elf-entities';
import { createRequestDataSource } from '@ngneat/elf-requests';
import { auditsOperationStore } from './audits-operation.store';

export const getAuditsOperationDataSource = createRequestDataSource({
  store: auditsOperationStore,
  data$: () => auditsOperationStore.pipe(selectAllEntities()),
  requestKey: 'getAuditsInformationOP',
  dataKey: 'auditsInfoOP',
});

